<template>
    <access-denied v-if="accessDenied" title="empresa" />
    <router-view v-else />
</template>

<script>
export default {
    data() {
        return {
            accessDenied: false,
        };
    },
    created() {
        let isUpdate = false;
        if (this.$route.params.id) isUpdate = true;

        if (this.$route.meta.abrev == 'ven') {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'des') {
            this.permissao = this.hasPermissionAccess(
                'des',
                'empresa',
                'des-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'agro') {
            this.permissao = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-dados-cadastrais'
            );
        }

        if ((!isUpdate && !this.permissao.create) || (isUpdate && !this.permissao.read)) {
            this.accessDenied = true;
            return
        }
    },
};
</script>
